import React from 'react';
import Routes from './routes';
import './App.css';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <div>
    <Routes />
    <ToastContainer />
    </div>
  );
}

export default App;
